module.exports = __webpack_public_path__ + "static/media/articleImage.faeec122.png";